<template>
  <div class="analysis">
    <div class="top wbg" v-if='$common.AUTH("statis:cause")'>
      <Top @search="search"></Top>
      <!-- :lineData='lineData' -->
      <Statistics :data='chart'></Statistics>
    </div>
    <div class="bot" v-if='$common.AUTH("statis:cause")'>
      <div class="mainbot" style="padding-top:0;">
        <div class="h2" style="padding:0;">
          统计结果列表
        </div>
        <div class="tableList">
          <div class="table">
            <table>
              <thead>
                <td style="width: 70px;">序号</td>
                <td style="width: 70px;">被告</td>
                <td style="width: 160px;">证件号码/代码</td>
                <td style="width: 65px;">所属案件</td>
                <td width="190">原告</td>
                <td width="180">案号</td>
                <td width="200">管辖法院</td>
                <td width="100">当前进度</td>
                <td width="100">录入日期</td>
              </thead>
              <tbody>
                <tr v-for='(i, index) in newO.list' :key='index'>
                  <td>{{ index + 1 + (10 * (page.page - 1)) }}</td>
                  <td>
                    <span class="curpoter" @click='dbclick(i)'>
                      <Normap :tit='i.realname'>{{ i.realname }}</Normap>
                    </span>
                  </td>
                  <td>
                    <Normap :tit='i.chinaid'>{{ i.chinaid }}</Normap>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      案件{{ j.sort }}
                    </p>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      <Normap :tit='j.accuser || "/"'>{{ j.accuser || '/' }}</Normap>
                    </p>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      <Normap :tit='j.no || "/"'>{{ j.no || '/' }}</Normap>
                    </p>
                  </td>
                  <td>
                    <p v-for='j in i.cause'>
                      <Normap :tit='getSp(j.court)[1]'>{{ getSp(j.court)[1] }}</Normap>
                    </p>
                  </td>

                  <td>
                    <p v-for='j in i.cause'>
                      <Normap :tit='j.step_title || "/"'>{{ j.step_title || '/' }}</Normap>
                    </p>
                  </td>

                  <td>
                    <p v-for='j in i.cause'>
                      <Normap :tit='j.create_times | yearFormat'>{{ j.create_times | yearFormat }}</Normap>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="loadspin"> <a-spin class="spin" tip="加载中" :spinning="Loading" /></div>
          <div class="pages">
            <!-- <a href="javascript:void(0);" class="out" @click='print'>全部导出</a> -->
            <a-pagination v-model="page.page" show-quick-jumper :total="newO.count" show-less-items :pageSize='10'
              @change='turnpage' :show-total="(total) => `被告：${newO.count} 案件数：${newO.cause_count}`" />
          </div>
        </div>
      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>
<script>
import { nGetStepChart, NstepChartCauseList, outexport, causeAnalyse, analyseBook } from '@/server/collection'
import stepJSON from "@/page/ly/step.json"
import artStep from "@/page/ly/artStep.json"      //进度json
import { Tacitly } from '@/assets/js/Tacitly'
import Statistics from './statistics'
// import Solid from "@/page/collectionAmount/echarts/solid"
import Proposition from "./nStep.json"
import colorArr from "./color"
import sPie from "./charts/pie.vue"
import Top from './top.vue'

function tryNum(nums) {
  if (!nums) return 0
  else return nums
}
export default {
  components: { sPie, Top, Statistics },
  data() {
    return {
      startAll: 0,
      ckType: 2,
      newO: {
        cause_count: 0,
        list: [],
        count: 0
      },
      page: {
        page: 1,
        limit: 10
      },

      form: {
        reason_id: [],
        accuser_id: [],
        stime: '',
        etime: '',
        open_stime: '',
        open_etime: '',
        team_id: '',
        loan_status: []
      },
      stepTit: ["诉前准备", "一审", "二审", "重审", "再审", "审判监督", "执行"],
      step: stepJSON,
      myChart: null,
      time: [],
      stepCode: [],
      debtorAge: {
        list: [],
        all: 0
      },
      chart: {
        capital: {},
        lawyer_fee: {},
        travel_fee: {},
        sum: {}
      },
      mapLoad: false,
      all: false,
      Loading: false,
    }
  },
  created() {
    //  this.StepList = this.putStep()

    //this.stepCode = this.putStep().map(ele => { return ele.lite })

    this.search()
  },
  mounted() {

  },
  methods: {
    search(val, ckType) {
      if (val) {
        this.form = val
        this.page.page = 1;
      }
      // if(ckType){
      //   this.all=false;
      //   this.stepCode = ckType == 2 ? [] : ["3"]
      //   this.ckType=ckType
      //   this.getChart()
      // }
      this.step = val ? (val.cause_type == 1 ? stepJSON : artStep) : stepJSON
      this.stepTit = val ? (val.cause_type == 1 ? ["诉前准备", "一审", "二审", "重审", "再审", "审判监督", "执行"] : ["诉前准备", "仲裁", "二审", "重审", "再审", "审判监督", "执行"]) : ["诉前准备", "一审", "二审", "重审", "再审", "审判监督", "执行"]
      this.chart.fee_list = []
      this.getFee()
      this.getChart()
      //  this.getBook()
    },
    getBook() {
      this.$set(this.lineData, 'load', false)
      analyseBook(this.form).then(e => {
        const all = e.cpws1.cause_count + e.cpws2.cause_count + e.cpws3.cause_count
        this.lineData = {
          load: true,
          label: ['调解书', '判决书', '其他'],
          list: [e.cpws1.cause_count, e.cpws2.cause_count, e.cpws3.cause_count],
          arr: [e.cpws1.cause_count / all, e.cpws2.cause_count / all, e.cpws3.cause_count / all]
        }
      })
    },
    getSp(val) {
      if (val) {
        let arr = val.split(",")
        return [arr[0], arr[arr.length - 1]]
      } else
        return ["", ""]
    },
    print() {
      let http = Tacitly.Base_Port
      let form = this.form
      this.$modal.confirm({
        content: '确认导出这个文件？',
        onOk: () => {
          window.open(`${http}${this.ckType == 1 ? "export/stepCauseList?" : "export/maxStepCauseList?"}accuser_id=${form.accuser_id}&team_id=${form.team_id}&stime=${form.stime}&etime=${form.etime}&stepCode=${this.stepCode}`)
        }
      });
    },
    dbclick(record) {
      if (this.$common.AUTH('debtor:info')) {
        let routeUrl = this.$router.resolve({ "name": "lydetails", params: { "id": record.debtor_id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    mouse(j) {
      if (this.mapLoad) {
        this.myChart.dispatchAction({
          type: 'showTip',
          name: j.name,
          seriesIndex: 0
        })
      }
    },
    mouseout(j) {
      if (this.mapLoad) {
        this.myChart.dispatchAction({
          type: 'hideTip',
        })
      }
    },
    init() {
      let myChart = this.$echarts.init(document.getElementById("piebox"))
      this.myChart = myChart
      let _this = this;
      const startAll = this.chart.sum.cause_count     //总数
      const stepCode = this.stepCode
      let list = []
      if (_this.ckType == 2) {
        list = _this.debtorAge.list.map((ele, index) => { return { name: ele.title, value: ele.count, itemStyle: { color: '#eee', inColor: colorArr[index], emphasis: { color: '#eee' } }, avoidLabelOverlap: false, step: ele.step } }).filter(ele => { return ele.value > 0 })
        list.map(ele => {
          ele.hoverAnimation = stepCode.indexOf(ele.step + '') >= 0
          ele.itemStyle.color = stepCode.indexOf(ele.step + '') >= 0 ? ele.itemStyle.inColor : '#eee'
          ele.itemStyle.emphasis.color = stepCode.indexOf(ele.step + '') >= 0 ? ele.itemStyle.inColor : '#eee'
        })
        list.sort((a, b) => {
          return b.hoverAnimation - a.hoverAnimation
        })
        if (this.chart.sum.cause_count > this.startAll) {
          list.push({
            step: 200,
            hoverAnimation: false,
            name: '无进度', value: this.chart.sum.cause_count - this.startAll, itemStyle: {
              color: '#eee', inColor: '#eee', emphasis: { color: '#eee' }
            }
          })
        }
      }
      let option = {
        //    color: colorArr,
        tooltip: {
          show: true,
          padding: 0,
          enterable: true,
          textStyle: {
            color: '#000',
            decoration: 'none',
          },
          formatter: function (params) {
            const value = params.data.value
            if (stepCode.indexOf(params.data.step + '') < 0 && params.data.step < 1000) {
              return ''
            } else {
              let tipHtml = `<div class='tipbox'>
                  <div class='tit'>${params.name}</div>
                  <div class='p'>数量:${value}</div>
                    <div class='p zb'>占比:${(value / startAll * 100).toFixed(2)}%</div>
              </div>`
              return tipHtml;
            }
          }
        },
        series: [
          {
            type: 'pie',
            radius: [0, 150],
            label: {
              show: false
            },
            data: _this.ckType == 2 ?
              list :
              [
                {
                  hoverAnimation: true,
                  name: _this.debtorAge.list[0].title, value: _this.debtorAge.list[0].count, itemStyle: { color: '#c0e4f0' },
                  step: _this.debtorAge.list[0].step
                },
                {
                  hoverAnimation: true,
                  name: '其他进度', value: startAll - _this.debtorAge.list[0].count, itemStyle: { color: '#bac8e5' },
                  step: 1111
                }
              ]
          }
        ],

      };
      myChart.setOption(option)
    },
    turnpage(val) {
      this.newO.page = val;
      this.getList()
    },
    rPropo(Arr) {
      let newArr = []
      Proposition.map(ele => {
        let s = Arr.find(s => { return s.type === ele.type * 1 })
        if (s) {
          newArr.push({
            type_title: ele.tit,
            type: ele.type,
            data: { "qrzq": s.qrzq, "zzzq": s.zzzq }
          })
        }
      })
      return newArr
    },
    putStep() {
      let StepList = []
      for (let val in JSON.parse(JSON.stringify(this.step))) {
        StepList = StepList.concat(this.step[val])
      }
      return StepList
    },
    lick(item) {
      let stepCode = JSON.parse(JSON.stringify(this.stepCode));
      if (this.ckType == 2) {
        if (stepCode.indexOf(item.lite) >= 0) {
          let index = stepCode.findIndex(ele => { return ele == item.lite })
          stepCode.splice(index, 1)
        } else {
          stepCode.push(item.lite)
        }
        this.stepCode = stepCode
        this.all = this.stepCode.length == 28
        // this.init()
        this.getList()
      }
      else {
        stepCode = [item.lite]
        this.stepCode = stepCode
        this.getChart()
      }
    },
    // pickCK(e) {
    //   const value = e.target.value
    //   this.$set(this.chart, "rights", this.chart[value])
    // },
    getFee() {
      let form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        if (typeof form[val] == 'object' && form[val]) {
          form[val] = form[val].toString()
        }
      }
      causeAnalyse(form).then(e => {
        this.chart = e
      })
    },


    // outCk(val) {
    //   //  this.stepCode = this.ckType == 2 ? this.putStep().map(ele => { return ele.lite }) : ["3"]
    //   this.stepCode = this.ckType == 2 ? [] : ["3"]
    //   this.getChart()
    // },
    getChart() {
      this.page.page = 1;
      this.mapLoad = false;
      let form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        if (typeof form[val] == 'object' && form[val]) {
          form[val] = form[val].toString()
        }
      }

      nGetStepChart(Object.assign(form, { step: this.ckType == 2 ? this.putStep().map(ele => { return ele.lite }).toString() : this.stepCode, type: this.ckType })).then(e => {
        this.mapLoad = true;
        if (!this.startAll || this.startAll == 0) {
          let all = 0;
          e.list.filter(ele => { return (ele.step < 111 || ele.step > 114) }).map((ele) => {
            all += ele.count
          })
          this.startAll = all
        }
        setTimeout(s => {
          this.debtorAge.list = e.list
          // this.init()
        }, 200)
      })
      this.getList()
    },
    getList() {
      this.Loading = true
      let form = JSON.parse(JSON.stringify(this.form))
      for (let val in form) {
        if (typeof form[val] == 'object' && form[val]) {
          form[val] = form[val].toString()
        }
      }
      NstepChartCauseList(Object.assign(form, { step: this.stepCode.toString(), type: this.ckType }, this.page)).then(e => {
        this.newO = e
        this.Loading = false
      })
    }
  },
}
</script>
<style lang="less">
.rtcharts,
.statistics .rt {
  position: relative;

  .loads {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .tipbox {
    width: 160px;
    box-shadow: 0 0 3px #ccc;
    padding: 10px;
    background: #fff;

    .p {
      display: flex;
      align-items: center;

      &::before {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        content: "";
        background: #52c41a;
        margin-right: 4px;
      }
    }

    .zb {
      &::before {
        background: #40a9ff;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.loadspin {
  position: absolute;
  top: 53%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.analysis {
  .top {
    padding: 20px 20px 30px;
    box-sizing: border-box;

    .to {
      width: 20px;
      height: 1px;
      background: #dbdcde;
      display: inline-block;
      margin: 0 10px;
    }

    .moneyp {
      height: 210px;
      display: flex;
      align-items: center;

      .hd {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: center;
        width: 300px;
        position: relative;
        margin-right: 10px;
        height: 210px;
        background: #f6f8fc;

        .tp,
        .smlbox {
          height: 100px;
        }

        .tp {
          display: flex;
          align-items: center;
          flex-direction: column;
          height: 110px;
          padding-top: 40px;
        }

        .smlbox {
          display: flex;
          border-top: 1px solid #89c1fd;

          .li {
            flex: 1;
            display: flex;
            align-items: center;
            padding-top: 1.25rem;
            flex-direction: column;
            position: relative;

            label {
              color: rgba(14, 41, 73, 0.6);
            }

            .say {
              line-height: 20px;
              font-size: 1rem;
              color: #1e8bfe;
              font-weight: bold;

              span {
                font-size: 0.875rem;
              }
            }

            &:nth-child(1)::after {
              width: 1px;
              height: 30px;
              background: #ddd;
              content: "";
              display: block;
              position: absolute;
              right: 0;
              top: 24px;
            }
          }
        }

        .t {
          font-size: 0.875rem;
          color: rgba(14, 41, 73, 0.6);
          line-height: 20px;
        }

        .money {
          font-size: 1.5rem;
          color: #1e8bfe;
          line-height: 28px;

          span {
            font-size: 0.875rem;
            color: rgba(14, 41, 73, 0.6);
          }
        }
      }

      .rt {
        background: #f6f8fc;
        width: 345px;
        height: 100%;
        margin-left: 10px;
        padding: 20px 20px 10px;
      }

      .inset {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        // justify-content: center;
        flex: 3;
        height: 210px;
        background: #f6f8fc;

        .tit {
          text-align: center;
          position: absolute;
          width: 100%;
          left: 0;
          font-size: 0.875rem;
          color: #0e2949;
          line-height: 20px;
          bottom: 10px;
        }

        .p {
          width: 20%;
          padding-right: 10px;
          font-size: 0.875rem;
          color: rgba(14, 41, 73, 0.6);
          line-height: 17px;
          margin-bottom: 18px;
          position: relative;
          margin: 0;
          margin-bottom: -10px;
        }

        .n {
          margin: 0;
        }
      }
    }
  }

  .smlbox {}

  .bot {
    margin-top: 10px;
    background: #fff;
    // border-radius: 8px;

    .h2 {
      line-height: 62px;
      padding-left: 20px;
      font-size: 1rem;
      color: #0e2949;
      font-weight: bold;
      border-bottom: 1px solid #efefef;
    }

    .mainbot {
      padding: 20px;
      box-sizing: border-box;

      .tpbox {
        display: flex;
        background: #f6f8fc;
        padding: 0 20px;
      }

      .select {
        flex: 1;

        .dl {
          width: 100%;
          height: 54px;
          font-size: 0.875rem;
          color: #0e2949;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 0.875rem;
          border-bottom: 1px solid #efefef;

          &:nth-last-child(1) {
            border: 0 none;
          }

          .dt {
            width: 90px;
            font-weight: bold;
          }

          .dd {
            flex: 4;
            display: flex;

            .a {
              margin-right: 30px;
              color: rgba(14, 41, 73, 0.6);
              cursor: pointer;
            }

            .cur {
              color: #1e8bfe;
            }
          }
        }
      }

      .rtcharts {
        flex: 1;
      }
    }
  }

  .tableList {
    margin-top: 30px;
    width: 100%;
    position: relative;

    .table {


      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p {
            padding: 10px 10px 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }

  .pages {
    text-align: right;
    position: relative;

    .out {
      width: 96px;
      line-height: 32px;
      background: #fff;
      text-align: center;
      font-size: 0.875rem;
      color: #1e8bfe;
      border-radius: 4px;
      border: 1px solid #1d8bfe;
      display: block;
      position: absolute;
      left: 0;
      top: 40px;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
        color: #fff;
      }
    }
  }
}

.labelck {
  margin-bottom: 20px;

  b {
    font-size: 1rem;
    color: #0e2949;
    margin-right: 5px;
  }
}
</style>